import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { WellLogsModel } from './model/well-logs.model';
import { environment } from '../../../../environments/environment';

@Injectable()
export class WellLogsBackend {
  private API_ROOT = environment.apiUrl;

  private HEADERS = new HttpHeaders({ 'content-type': 'application/json' });

  constructor(private http: HttpClient) {}

  getAllWellLogs(requestObj): Observable<HttpResponse<any>> {
    const url = `${this.API_ROOT}/well-logs`;
    return this.http.post<WellLogsModel[]>(url, requestObj, this.getOptions());
  }

  getWellLogDetailsById(id): Observable<HttpResponse<any>> {
    const url = `${this.API_ROOT}/well-logs/${id}`;
    return this.http.get<any>(url, this.getOptions());
  }

  getAllNotes(obj): Observable<HttpResponse<any>> {
    const url = `${this.API_ROOT}/notes`;
    return this.http.post<any>(url, obj, this.getOptions());
  }

  private getOptions(): {
    headers: HttpHeaders;
    observe: 'response';
    params:
      | HttpParams
      | {
          [param: string]: string | string[];
        };
  } {
    return {
      headers: this.HEADERS,
      observe: 'response',
      params: {
        t: `${new Date().getTimezoneOffset()}`,
      },
    };
  }
}
